
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightningHeavyRain as ObiLightningHeavyRainElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-lightning-heavy-rain.js';
 
 
 

 
 export const ObiLightningHeavyRain = createComponent({
   react: React,
   tagName: 'obi-lightning-heavy-rain',
   elementClass: ObiLightningHeavyRainElement,
   events: {
     
   }
  });
 
 